import "../sass/child-styles.scss"

import SearchBox from "./modules/SearchBox";

const searchBox = new SearchBox();